<nav class="main-menu col-md-2 d-none d-md-block bg-dark" [ngClass]="{'nav-list-open': true}">
  <div class="side-bar-item">
    <app-menu
      *ngFor="let item of itemList"
      [item]="item"
      [selectedItem]="selectedItem"
      [onSelect]="onSelect.bind(this)"
    ></app-menu>
  </div>
</nav>
